import { Command } from '@approvalmax/types';

export const getDisabled = (disabled: boolean | undefined, command: Command | undefined) => {
    return disabled || (command && command.disabled) || false;
};
